import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { AboutReveal } from "./about-reveal";
import { useSiteLanguage } from "@/lib/useSiteLanguage";
import { aboutCtaCopy } from "@/lib/aboutPageCopy";

export function AboutCta() {
  const lang = useSiteLanguage();
  const t = aboutCtaCopy[lang];

  return (
    <section className="bg-background pb-20 md:pb-28 lg:pb-32">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <AboutReveal>
          <div className="relative overflow-hidden rounded-[1.5rem] bg-gradient-to-br from-sky-50 via-background to-amber-50/70 px-6 py-8 shadow-[0_16px_48px_-28px_rgba(0,0,0,0.28)] md:rounded-[1.75rem] md:px-10 md:py-9 dark:from-sky-950/35 dark:via-card dark:to-amber-950/25 dark:shadow-none">
            <div
              aria-hidden
              className="pointer-events-none absolute -left-16 top-0 h-36 w-36 rounded-full bg-sky-400/15 blur-3xl dark:bg-sky-500/10"
            />
            <div
              aria-hidden
              className="pointer-events-none absolute -bottom-16 -right-10 h-40 w-40 rounded-full bg-amber-400/15 blur-3xl dark:bg-amber-500/10"
            />

            <div className="relative z-10 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center sm:gap-8">
              <div className="max-w-xl">
                <span className="mb-3 inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
                  <Sparkles
                    className="h-3.5 w-3.5 text-amber-600 dark:text-amber-400"
                    strokeWidth={1.75}
                  />
                  {t.eyebrow}
                </span>
                <h2 className="text-balance text-xl font-bold tracking-tight text-foreground md:text-2xl">
                  {t.titleBefore}{" "}
                  <span className="bg-gradient-to-r from-sky-700 via-foreground to-amber-700 bg-clip-text text-transparent dark:from-sky-300 dark:via-foreground dark:to-amber-300">
                    {t.titleAccent}
                  </span>
                </h2>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-muted-foreground">
                  {t.body}
                </p>
              </div>

              <div className="relative z-10 flex shrink-0 flex-col gap-2.5 sm:flex-row sm:items-center">
                <Link
                  to="/contact"
                  className="group inline-flex items-center justify-center gap-2.5 rounded-full bg-foreground px-5 py-2.5 text-sm font-semibold text-background transition-all duration-300 ease-out hover:scale-[1.02] hover:opacity-95"
                >
                  {t.primaryCta}
                  <ArrowRight
                    className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5"
                    strokeWidth={2.25}
                  />
                </Link>
                <Link
                  to="/work"
                  className="relative z-10 inline-flex items-center justify-center rounded-full border border-border bg-background px-5 py-2.5 text-sm font-medium text-foreground transition-colors duration-300 hover:bg-muted"
                >
                  {t.secondaryCta}
                </Link>
              </div>
            </div>
          </div>
        </AboutReveal>
      </div>
    </section>
  );
}
